import { TProductParams } from 'feature/appeals/type'

import { InputCheckbox } from './components/InputCheckbox'
import { InputDropdown } from './components/InputDropdown'
import { InputText } from './components/InputText'

type TProductsPropsInputType = {
  parameter: TProductParams
}

// получение поля по типу параметра

export function ProductsPropsInputType({ parameter }: TProductsPropsInputType) {
  switch (parameter.typeCode) {
    case 'NUMBER':
      return <InputText parameter={parameter} type='number' />
    case 'TEXT':
      return <InputText parameter={parameter} />
    case 'DROPDOWN':
      return <InputDropdown parameter={parameter} />
    case 'CHECKBOX':
      return <InputCheckbox parameter={parameter} />
    default:
      return <></>
  }
}
